<template>
  <div>
    <div class="">
      <v-alert
        dense
        border="left"
        type="warning"
        dismissible
        v-if="exampleFileData?.need_to_show_message"
      >
        <span v-html="exampleFileData?.message"></span>
      </v-alert>
    </div>
    <div class="px-6">
      <div class="row pt-2">
        <!--        <div class="col-sm-6 col-12">-->
        <!--          <v-select-->
        <!--            clearable-->
        <!--            dense-->
        <!--            outlined-->
        <!--            label="Carrier"-->
        <!--            v-model="formData.carrier"-->
        <!--            :items="importTypeData.data.carriers"-->
        <!--            item-text="text"-->
        <!--            item-value="index"-->
        <!--            class="px-2"-->
        <!--            :error-messages="carrierErrors"-->
        <!--            @input="$v.formData.carrier.$touch()"-->
        <!--            @blur="$v.formData.carrier.$touch()"-->
        <!--          ></v-select>-->
        <!--        </div>-->

        <div class="col-12 col-sm-12 col-md-6">
          <v-select
            clearable
            dense
            outlined
            :label="$t('system')"
            v-model="formData.system"
            :items="importTypeData.data.systems"
            item-text="name"
            item-value="id"
            class="px-2"
            :error-messages="systemErrors"
            @input="$v.formData.system.$touch()"
            @blur="$v.formData.system.$touch()"
          ></v-select>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <v-select
            clearable
            dense
            outlined
            label="Type"
            v-model="formData.type_id"
            :items="importTypeData.data.types"
            item-text="name"
            item-value="id"
            class="px-2"
            :error-messages="type_idErrors"
            @input="$v.formData.type_id.$touch()"
            @blur="$v.formData.type_id.$touch()"
          ></v-select>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-8 col-md-9">
          <v-file-input
            v-model="formData.file"
            clearable
            ref="file_uploader"
            :label="$t('file_input')"
            outlined
            dense
            required
            :error-messages="fileErrors"
            @input="$v.formData.file.$touch()"
            @blur="$v.formData.file.$touch()"
          ></v-file-input>
        </div>
        <div class="col-12 col-sm-4 col-md-3 text-center">
          <v-btn
            class="primary--text"
            outlined
            text
            :href="exampleFileData.url"
            :disabled="!exampleFileData"
          >
            {{ exampleFileData ? exampleFileData.title : $t("download_template") }}
          </v-btn>
        </div>
      </div>
    </div>
    <div class="mb-4 d-flex flex-grow-1 align-end justify-center mt-4">
      <button
        type="reset"
        class="btn btn-light me-3 px-5 py-3 ls1"
        @click="resetForm"
      >
        {{ $t("clear") }}
      </button>
      <button
        type="submit"
        class="btn btn-info px-5 py-3 ls1"
        @click="submitForm"
      >
        {{ $t("upload") }}
      </button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "OrderStatusForm",
  mixins: [validationMixin],
  validations: {
    formData: {
      file: { required },
      system: { required },
      type_id: { required },
      // carrier: { required },
    },
  },
  props: {
    importTypeData: {
      required: true,
      type: Object,
    },
    submit: {
      required: true,
      type: Function,
    },
  },
  data: () => ({
    formData: {
      system: null,
      // carrier: null,
      file: null,
      type_id: null,
    },
  }),
  computed: {
    exampleFileData: function () {
      if (this.formData.type_id && this.importTypeData.data.files) {
        return this.importTypeData.data.files.find(
          (file) => file.type === `${this.formData.type_id}_upload`
        );
      } else {
        return false;
      }
    },
    systemErrors() {
      return this.handleFormValidation("system", this);
    },
    // carrierErrors() {
    //   return this.handleFormValidation("carrier", this);
    // },
    fileErrors() {
      return this.handleFormValidation("file", this);
    },
    type_idErrors() {
      return this.handleFormValidation("type_id", this);
    },
  },
  methods: {
    handleFormValidation(fieldName, vueObj) {
      const errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;

      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      return errors;
    },
    submitForm() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      let data = new FormData();
      data.append("file", this.formData.file, this.formData.file.name);
      data.append("type", this.importTypeData.type);
      // data.append("carrier_id", this.formData.carrier);
      data.append("systems", this.formData.system);

      const success = this.submit(data);
      if (success) {
        this.$nextTick(() => {
          this.resetForm();
        });
      } else {
        return;
      }
    },
    resetForm() {
      this.formData = {
        system: null,
        // carrier: null,
        file: null,
        type_id: null,
      };
    },
  },
};
</script>

<style></style>
